import { makeRequest } from '../utils/apiUtils';

export const GET_WM_OFFER_SUBSCRIPTION = 'wmOfferSubscription/GET_WM_OFFER_SUBSCRIPTION';
export const GET_WM_OFFER_SUBSCRIPTION_SUCCESS = 'wmOfferSubscription/GET_WM_OFFER_SUBSCRIPTION_SUCCESS';
export const GET_WM_OFFER_SUBSCRIPTION_FAIL = 'wmOfferSubscription/GET_WM_OFFER_SUBSCRIPTION_FAIL';

export function getWmOfferSubscription(offerId = []) {
  const offers = offerId.map(item => 'offer[]=' + item).join('&');
  return makeRequest(`/saduka/wmOfferSubscription?${offers}`, {
    types: [GET_WM_OFFER_SUBSCRIPTION, GET_WM_OFFER_SUBSCRIPTION_SUCCESS, GET_WM_OFFER_SUBSCRIPTION_FAIL],
    options: {
      credentials: 'include'
    },
    offerId
  });
}
